var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Mesh, MeshBasicMaterial, Object3D, PlaneGeometry, Vector2, Vector3 } from 'three';
import WelcomeScreen from '../components/WelcomeScreen';
import { ActionControllerEventName, ButtonComponent, Level, ResourcesManager, ResourceType, ScenarioProcessor, Viewer } from '@verybigthings/vbt-webvr-framework';
import { config, zSpaceConfig } from '../config';
import * as styleConfig from '../styleConfig';
import MainMenuComponent from '../components/MainMenuComponent';
import PetriLevel from './PetriLevel';
import MolarLevel from './MolarLevel';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
import { SpectrophotometerLevel } from './SpectrophotometerLevel';
import { TutorialVideoComponent } from '../components/TutorialVideoComponent';
import { InputManager } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/InputManager';
import MicropipetteLevel from './MicropipetteLevel';
import SerologicalLevel from './SerologicalLevel';
import { SessionController } from '@verybigthings/cerify-ed-simulation--backend-connect';
import { VARIABLES } from '../utils/VARIABLES';
import ChangeModeModal from '../utils/ChangeModeModal/ChangeModeModal';
export default class Lobby extends Level {
    constructor(app, envConfig) {
        super(config);
        this.levelList = [];
        this.muted = false;
        this.videoIsRunning = false;
        this.resultsSent = false;
        window['lobby'] = this;
        this.app = app;
        this.uiObject.raycast = () => {
        };
        this.requireTextures();
        this.resourcesInUse = [
            {
                name: 'spectrophotometer_apparat',
                type: ResourceType.FBX_MODEL,
                priority: 0,
                url: require(`../../assets/${this.app.modelsFolder}/spectrophotometer/spectrophotometer_apparat.fbx`)
            },
            // CLOCK =======
            {
                name: `MODEL_clock`,
                url: require('../../assets/models/petri/clock2.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `MAP_clock_time`,
                url: require(`../../assets/${this.app.texturesFolder}/petri/time.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            // MODELS
            {
                name: `lobby_table`,
                url: require('../../assets/models/lobby_table.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `table_colored2`,
                url: require('../../assets/models/table_colored2.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `table_colored3`,
                url: require('../../assets/models/table_colored3.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `table_colored4`,
                url: require('../../assets/models/table_colored4.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `table_colored5`,
                url: require('../../assets/models/table_colored5.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `table_colored6`,
                url: require('../../assets/models/table_colored6.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            // PETRI =======
            {
                name: `petri_table`,
                url: require('../../assets/models/petri/table.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `petri_guide`,
                url: require(`../../assets/${this.app.texturesFolder}/petri/guide.jpg`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: `petri_alco`,
                url: require('../../assets/models/petri/alcohol_alco.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `petri_spray`,
                url: require('../../assets/models/petri/alcohol_spray.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `petri_rag`,
                url: require('../../assets/models/petri/rag.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `petri_burner`,
                url: require('../../assets/models/petri/bunsen_burner.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `petri_loop`,
                url: require('../../assets/models/petri/loop.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `petri_drops`,
                url: require('../../assets/models/petri/drops.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `petri_spots_1`,
                url: require('../../assets/models/petri/spots_1.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `petri_spots_2`,
                url: require('../../assets/models/petri/spots_2.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `petri_dish_empty`,
                url: require(`../../assets/${this.app.modelsFolder}/petri/petri_empty.fbx`),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: 'petri_dish_green',
                url: require(`../../assets/${this.app.modelsFolder}/petri/petri_green.fbx`),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: 'petri_dish_red',
                url: require(`../../assets/${this.app.modelsFolder}/petri/petri_red.fbx`),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: 'petri_blue_empty',
                url: require('../../assets/models/petri/blue_petri.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: 'petri_dish_cap',
                url: require('../../assets/models/petri/dish_cap.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: 'petri_wax_on_cap',
                url: require('../../assets/models/petri/wax_on_cap.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: 'petri_wax_tape',
                url: require('../../assets/models/petri/wax_tape.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: 'petri_incubator',
                url: require('../../assets/models/petri/incubator.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: 'petri_incubator_door',
                url: require('../../assets/models/petri/incubator_door.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            // MICROPIPETTE ============
            {
                name: `micropipette_table`,
                url: require('../../assets/models/micropipette/table.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `micropipette_holder_1`,
                url: require('../../assets/models/micropipette/holder_1.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `micropipette_holder_3`,
                url: require('../../assets/models/micropipette/holder_3.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `micropipette_pipette`,
                url: require('../../assets/models/micropipette/micropipette.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `micropipette_tips_holder`,
                url: require('../../assets/models/micropipette/tips_holder.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `micropipette_trash_can`,
                url: require('../../assets/models/micropipette/trash_can.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `micropipette_pipette_holder`,
                url: require('../../assets/models/micropipette/pipette_holder.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            // SEROLOGICAL ===============
            {
                name: `serological_table`,
                url: require('../../assets/models/serological/table.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `serological_pipette_5`,
                url: require('../../assets/models/serological/pipette_5.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `serological_pipette_3`,
                url: require('../../assets/models/serological/pipette_3.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `serological_pipette_8`,
                url: require('../../assets/models/serological/pipette_8.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `serological_test_tube_red_5`,
                url: require('../../assets/models/serological/test_tube_red_5.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `serological_test_tube_red_3`,
                url: require('../../assets/models/serological/test_tube_red_3.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `serological_test_tube_red_8`,
                url: require('../../assets/models/serological/test_tube_red_8.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `serological_pipette_holder`,
                url: require('../../assets/models/serological/pipette_holder.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `serological_jar`,
                url: require('../../assets/models/serological/jar.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: `serological_jar_tripod`,
                url: require('../../assets/models/serological/jar_tripod.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            // MOLAR =======
            {
                name: 'scene_molar',
                url: require('../../assets/models/molar/molar_scene_planes.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: 'periodic_table',
                url: require(`../../assets/${this.app.texturesFolder}/molar/periodic_table.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'periodic_element_Na',
                url: require(`../../assets/${this.app.texturesFolder}/molar/Sodium.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'periodic_element_Cl',
                url: require(`../../assets/${this.app.texturesFolder}/molar/chlorine.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'periodic_element_NaCl',
                url: require(`../../assets/${this.app.texturesFolder}/molar/Sodiumchloride.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'plus',
                url: require(`../../assets/${this.app.texturesFolder}/molar/Add.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'divide',
                url: require(`../../assets/${this.app.texturesFolder}/molar/Divide.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'equals',
                url: require(`../../assets/${this.app.texturesFolder}/molar/Equals.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'spoon_0_1',
                type: ResourceType.FBX_MODEL,
                priority: 0,
                url: require('../../assets/models/molar/spoon_0_1.fbx')
            },
            {
                name: 'spoon_0_1_w_salt',
                type: ResourceType.FBX_MODEL,
                priority: 0,
                url: require('../../assets/models/molar/spoon_0_1_w_salt.fbx')
            },
            {
                name: 'spoon_0_5',
                type: ResourceType.FBX_MODEL,
                priority: 0,
                url: require('../../assets/models/molar/spoon_0_5.fbx')
            },
            {
                name: 'spoon_0_5_w_salt',
                type: ResourceType.FBX_MODEL,
                priority: 0,
                url: require('../../assets/models/molar/spoon_0_5_w_salt.fbx')
            },
            {
                name: 'spoon_1',
                type: ResourceType.FBX_MODEL,
                priority: 0,
                url: require('../../assets/models/molar/spoon_1.fbx')
            },
            {
                name: 'spoon_1_w_salt',
                type: ResourceType.FBX_MODEL,
                priority: 0,
                url: require('../../assets/models/molar/spoon_1_w_salt.fbx')
            },
            {
                name: 'TEXTURE_spoon_0_1',
                type: ResourceType.TEXTURE,
                priority: 0,
                url: require(`../../assets/${this.app.texturesFolder}/molar/spoon0_1.jpg`)
            },
            {
                name: 'TEXTURE_spoon_0_5',
                type: ResourceType.TEXTURE,
                priority: 0,
                url: require(`../../assets/${this.app.texturesFolder}/molar/spoon0_5.jpg`)
            },
            {
                name: 'TEXTURE_spoon_1',
                type: ResourceType.TEXTURE,
                priority: 0,
                url: require(`../../assets/${this.app.texturesFolder}/molar/spoon1.jpg`)
            },
            // VIDEOS =======
            {
                name: 'Level_1_video',
                // Changing path depending on local/build
                url: !VARIABLES.PRODUCTION_ENVIRONMENT ? require('../../assets/videos/pano.webm') : ('https://certify-ed.s3.amazonaws.com/video/Biotechnology/Biotech+VR+Sim+Videos/Bacterial_Isolation_on_Petri_Dish.webm'),
                priority: 0,
                type: ResourceType.VIDEO,
                crossOrigin: !VARIABLES.PRODUCTION_ENVIRONMENT ? 'use-credentials' : 'anonymous'
            },
            {
                name: 'Level_2_video',
                url: !VARIABLES.PRODUCTION_ENVIRONMENT ? require('../../assets/videos/pano.webm') : ('https://certify-ed.s3.amazonaws.com/video/Biotechnology/Biotech+VR+Sim+Videos/Using_Volumetric_Equipment_Using_Micropipettes.webm'),
                priority: 0,
                type: ResourceType.VIDEO,
                crossOrigin: !VARIABLES.PRODUCTION_ENVIRONMENT ? 'use-credentials' : 'anonymous'
            },
            {
                name: 'Level_3_video',
                url: !VARIABLES.PRODUCTION_ENVIRONMENT ? require('../../assets/videos/pano.webm') : ('https://certify-ed.s3.amazonaws.com/video/Biotechnology/Biotech+VR+Sim+Videos/Serological_Pipettes_Using_Volumetric+Equipment.webm'),
                priority: 0,
                type: ResourceType.VIDEO,
                crossOrigin: !VARIABLES.PRODUCTION_ENVIRONMENT ? 'use-credentials' : 'anonymous'
            },
            {
                name: 'Level_4_video',
                url: !VARIABLES.PRODUCTION_ENVIRONMENT ? require('../../assets/videos/pano.webm') : ('https://certify-ed.s3.amazonaws.com/video/Biotechnology/Biotech+VR+Sim+Videos/Biotech_Molar_Solution.webm'),
                priority: 0,
                type: ResourceType.VIDEO,
                crossOrigin: !VARIABLES.PRODUCTION_ENVIRONMENT ? 'use-credentials' : 'anonymous'
            },
            {
                name: 'Level_5_video',
                url: !VARIABLES.PRODUCTION_ENVIRONMENT ? require('../../assets/videos/pano.webm') : ('https://certify-ed.s3.amazonaws.com/video/Biotechnology/Biotech+VR+Sim+Videos/Bio_Tech_Spectrophotometer.webm'),
                priority: 0,
                type: ResourceType.VIDEO,
                crossOrigin: !VARIABLES.PRODUCTION_ENVIRONMENT ? 'use-credentials' : 'anonymous'
            },
            // SOUNDS =====
            {
                name: 'spray_sound',
                url: require('../../assets/sounds/spray_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'fire_sound',
                url: require('../../assets/sounds/fire_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'dish_opening_sound',
                url: require('../../assets/sounds/dish_opening_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'wax_sound',
                url: require('../../assets/sounds/wax_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'stopwatch_sound',
                url: require('../../assets/sounds/stopwatch_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'put_sound',
                url: require('../../assets/sounds/put_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'water_pouring_sound',
                url: require('../../assets/sounds/water_pouring_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'sand_start_sound',
                url: require('../../assets/sounds/sand_start_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'sand_main_sound',
                url: require('../../assets/sounds/sand_main_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'sand_end_sound',
                url: require('../../assets/sounds/sand_end_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'sand_full_sound',
                url: require('../../assets/sounds/sand_full_sound.mp3'),
                priority: 0,
                type: ResourceType.AUDIO
            },
            {
                name: 'popup_decoration',
                url: require(`../../assets/${this.app.texturesFolder}/popups/header.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'particle_fire',
                url: require('../../assets/textures/petri/flame.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'spectro_graph',
                url: require(`../../assets/${this.app.texturesFolder}/spectro/spectro_graph.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
        ];
        // if (this.app.texturesFolder === 'textures') {
        if (window['quality'] !== 'very low') {
            this.resourcesInUse.push(
            // MODELS
            {
                name: 'molar_floor_shadow',
                url: require('../../assets/models/molar/floor_shadow.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            }, 
            // TEXTURES
            // PHONG78
            {
                name: `MAP_phong78`,
                url: require('../../assets/textures/molar/molar_scene_uv_norm_phong78_BaseColor.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, 
            // PHONG79
            {
                name: `MAP_phong79`,
                url: require('../../assets/textures/molar/molar_scene_uv_norm_phong79_BaseColor.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: 'table_low_DefaultMaterial_BaseColor',
                url: require('../../assets/textures/table_low_DefaultMaterial_BaseColor.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, 
            // MICROPIPETTE
            {
                name: `ALPHA_plane_mat21`,
                url: require(`../../assets/textures/micropipette/plane_mat21.jpg`),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat22`,
                url: require(`../../assets/textures/micropipette/plane_mat22.jpg`),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat23`,
                url: require(`../../assets/textures/micropipette/plane_mat23.jpg`),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat24`,
                url: require(`../../assets/textures/micropipette/plane_mat24.jpg`),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat25`,
                url: require(`../../assets/textures/micropipette/plane_mat25.jpg`),
                priority: 0,
                type: ResourceType.TEXTURE
            }, 
            // MOLAR
            {
                name: `ALPHA_lambert7`,
                url: require('../../assets/textures/molar/molar_scene_planes_big_lambert7_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_lambert8`,
                url: require('../../assets/textures/molar/molar_scene_planes_big_lambert8_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_lambert10`,
                url: require('../../assets/textures/molar/table_w_funnel_lambert10_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_lambert11`,
                url: require('../../assets/textures/molar/table_w_cap_lambert11_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_lambert12`,
                url: require('../../assets/textures/molar/molar_scene_planes_big_lambert12_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_lambert13`,
                url: require('../../assets/textures/molar/table_w_banka_lambert13_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_lambert14`,
                url: require('../../assets/textures/molar/table_w_water_lambert14_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_lambert15`,
                url: require('../../assets/textures/molar/table_w_flask_lambert15_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: 'molar_floor_shadow_alpha',
                url: require('../../assets/textures/molar/floor_shadow_alpha.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: 'table_low_DefaultMaterial_Alpha',
                url: require('../../assets/textures/table_low_DefaultMaterial_Alpha.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: 'table_low_DefaultMaterial_Normal',
                url: require('../../assets/textures/table_low_DefaultMaterial_Normal.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `NORMAL_phong78`,
                url: require('../../assets/textures/molar/molar_scene_uv_norm_phong78_Normal.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `NORMAL_phong79`,
                url: require('../../assets/textures/molar/molar_scene_uv_norm_phong79_Normal.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, 
            // SEROLOGICAL
            {
                name: `ALPHA_plane_mat31`,
                url: require('../../assets/textures/serological/plane_mat31.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat32`,
                url: require('../../assets/textures/serological/plane_mat32.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, 
            // PETRI
            {
                name: `ALPHA_plane_mat2`,
                url: require('../../assets/textures/petri/alcohol_alco_lambert1_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat3`,
                url: require('../../assets/textures/petri/alcohol_spray_lambert1_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat4`,
                url: require('../../assets/textures/petri/blue_petri_lambert1_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat5`,
                url: require('../../assets/textures/petri/bunsen_burner_lambert3_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat6`,
                url: require('../../assets/textures/petri/incubator_lambert1_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat7`,
                url: require('../../assets/textures/petri/loop_lambert1_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat8`,
                url: require('../../assets/textures/petri/rag_lambert1_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat9`,
                url: require('../../assets/textures/petri/wax_tape_lambert1_AO.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, 
            // SPECTROPHOTOMETER
            {
                name: `ALPHA_plane_mat41`,
                url: require('../../assets/textures/spectro/plane_mat41.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat42`,
                url: require('../../assets/textures/spectro/plane_mat42.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat43`,
                url: require('../../assets/textures/spectro/plane_mat43.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat44`,
                url: require('../../assets/textures/spectro/plane_mat44.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_mat45`,
                url: require('../../assets/textures/spectro/plane_mat45.jpg'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, 
            // TABLES SHADOW
            {
                name: `ALPHA_plane_table_mat1`,
                url: require('../../assets/textures/tables/plane_table_mat1.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_table_mat2`,
                url: require('../../assets/textures/tables/plane_table_mat2.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_table_mat3`,
                url: require('../../assets/textures/tables/plane_table_mat3.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_table_mat4`,
                url: require('../../assets/textures/tables/plane_table_mat4.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_table_mat5`,
                url: require('../../assets/textures/tables/plane_table_mat5.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: 'table_low_DefaultMaterial_Roughness',
                url: require('../../assets/textures/table_low_DefaultMaterial_Roughness.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: 'table_low_DefaultMaterial_AO',
                url: require('../../assets/textures/table_low_DefaultMaterial_AO.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            }, {
                name: `ALPHA_plane_table_mat`,
                url: require('../../assets/textures/tables/plane_table_mat.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            });
        }
        this.zSpacePositions = zSpaceConfig.lobby;
        this.cameraPosition = new Vector3(0, -8, 30);
        this.cameraTargetNormal = new Vector3(0, -8, 29.95);
        window['rm'] = ResourcesManager;
        this.addObject(this.spectrophotometerLevel = new SpectrophotometerLevel(5, 'Dilutions & \n Spectrophotometry', this), null, new Object3D());
        Viewer.scene.fog = null;
        Viewer.controls.enableZoom = true;
        Viewer.controls.enablePan = true;
        // console.log('ENABLED FIELD');
        // DebugGUI.enableField('zSpacePositionX');
        // DebugGUI.enableField('zSpacePositionY');
        // DebugGUI.enableField('zSpacePositionZ');
        // DebugGUI.enableField('zSpaceViewerScale');
        // DebugGUI.enableField('zSpaceYaw');
        // DebugGUI.enableField('zSpacePitch');
    }
    requireTextures() {
        const requiredAssests = [
            require('../../assets/textures_low/popups/header.png'),
            require('../../assets/textures/popups/header.png'),
            require('../../assets/textures_low/molar/periodic_table.png'),
            require('../../assets/textures/molar/periodic_table.png'),
            require('../../assets/textures_low/molar/Add.png'),
            require('../../assets/textures/molar/Add.png'),
            require('../../assets/textures_low/molar/chlorine.png'),
            require('../../assets/textures/molar/chlorine.png'),
            require('../../assets/textures_low/molar/Divide.png'),
            require('../../assets/textures/molar/Divide.png'),
            require('../../assets/textures_low/molar/Equals.png'),
            require('../../assets/textures/molar/Equals.png'),
            require('../../assets/textures_low/molar/Sodium.png'),
            require('../../assets/textures/molar/Sodium.png'),
            require('../../assets/textures_low/molar/Sodiumchloride.png'),
            require('../../assets/textures/molar/Sodiumchloride.png'),
            require('../../assets/textures_low/petri/guide.jpg'),
            require('../../assets/textures/petri/guide.jpg'),
            require(`../../assets/textures_low/petri/time.png`),
            require(`../../assets/textures/petri/time.png`),
            require('../../assets/textures_low/spectro/spectro_graph.png'),
            require('../../assets/textures/spectro/spectro_graph.png'),
            require('../../assets/textures_low/molar/spoon1.jpg'),
            require('../../assets/textures/molar/spoon1.jpg'),
            require('../../assets/textures_low/molar/spoon0_5.jpg'),
            require('../../assets/textures/molar/spoon0_5.jpg'),
            require('../../assets/textures_low/molar/spoon0_1.jpg'),
            require('../../assets/textures/molar/spoon0_1.jpg'),
            require('../../assets/models_low/spectrophotometer/spectrophotometer_apparat.fbx'),
            require('../../assets/models/spectrophotometer/spectrophotometer_apparat.fbx'),
            require('../../assets/models_low/petri/petri_empty.fbx'),
            require('../../assets/models/petri/petri_empty.fbx'),
            require('../../assets/models_low/petri/petri_green.fbx'),
            require('../../assets/models/petri/petri_green.fbx'),
            require('../../assets/models_low/petri/petri_red.fbx'),
            require('../../assets/models/petri/petri_red.fbx'),
        ]; // Just for webpack
    }
    resetApp() {
        this.levelList.forEach((level) => {
            // @ts-ignore
            if (!level.levelFinished)
                level.restart();
        });
        if (this.currentLevel !== this) {
            // @ts-ignore
            // !this.currentLevel.levelFinished && this.currentLevel && this.currentLevel.restart();
            this.exitToLobby();
        }
    }
    initZSpaceSettings() {
        Viewer.on('goToZSpace', () => {
            this.resetApp();
            // @ts-ignore
            this.levelList[3].spoonModule_1.uiObject.visible = this.levelList[3].spoonModule_0_1.uiObject.visible = this.levelList[3].spoonModule_0_5.uiObject.visible = false;
            console.log('goToZSpace--------');
            setTimeout(() => this.setZSpacePosition(), 150);
        });
        Viewer.on('goFromZSpace', () => {
            this.resetApp();
            // @ts-ignore
            this.levelList[3].spoonModule_1.uiObject.visible = this.levelList[3].spoonModule_0_1.uiObject.visible = this.levelList[3].spoonModule_0_5.uiObject.visible = true;
            console.log('goFromZSpace::::::::');
            setTimeout(() => this.setPCPosition(), 150);
        });
    }
    setZSpacePosition() {
        var _a;
        // @ts-ignore
        Viewer.controls.zController.setPosition(this.currentLevel.zSpacePositions.zSpacePosition.clone());
        // @ts-ignore
        Viewer.controls.zController.setViewerScale(this.currentLevel.zSpacePositions.viewerScale * this.app.determineZSpaceDevice.viewerScaleCoef);
        // @ts-ignore
        setTimeout(() => Viewer.controls.zController.setViewerScale(this.currentLevel.zSpacePositions.viewerScale * this.app.determineZSpaceDevice.viewerScaleCoef), 100);
        // @ts-ignore
        Viewer.controls.zController.setYaw(this.currentLevel.zSpacePositions.yaw);
        // @ts-ignore
        Viewer.controls.zController.setPitch(this.currentLevel.zSpacePositions.pitch);
        // @ts-ignore
        const currLevelzSpacePosition = this.currentLevel.zSpacePositions.zSpacePosition.clone();
        // @ts-ignore
        const currLevelzSpaceRotation = Viewer.controls.zController.quaternion.clone();
        this.wrapScreenUI.position.copy(currLevelzSpacePosition);
        this.wrapScreenUI.quaternion.copy(currLevelzSpaceRotation);
        this.tutorialVideo.uiObject.position.copy(currLevelzSpacePosition);
        this.tutorialVideo.uiObject.rotation.set(0, 0, 0);
        this.tutorialVideo.uiObject.scale.setScalar(2);
        if (this.currentLevel === this) {
            this.wrapHeaderUI.position.copy(currLevelzSpacePosition);
            this.wrapHeaderUI.position.y = -6.9;
            this.wrapHeaderUI.scale.setScalar(0.22);
            (_a = this.wrapScreenUI.parent) === null || _a === void 0 ? void 0 : _a.remove(this.wrapScreenUI);
        }
        else {
            // @ts-ignore
            this.currentLevel.uiContainer.quaternion.copy(currLevelzSpaceRotation);
            this.addObject(this.wrapScreenUI);
        }
        this.levelList.forEach((level) => {
            // @ts-ignore
            level.tasksProgress.uiObject.position.set(0, 6.8, 0);
            // @ts-ignore
            level.taskScreen.uiObject.position.set(10.4, 4.55, 0);
            // @ts-ignore
            this.addObject(level.uiContainer);
            // @ts-ignore
            level.uiContainer.position.copy(level.zSpacePositions.zSpacePosition);
            // @ts-ignore
            level.uiContainer.scale.setScalar(0.55);
            // @ts-ignore
            level.uiContainer.children.forEach(el => el.position.z = 0);
            // @ts-ignore
            this.addObject(level.title);
            // @ts-ignore
            level.title.uiObject.rotation.set(0, 0, 0);
            // @ts-ignore
            level.title.uiObject.scale.setScalar(0.4);
            // @ts-ignore
            level.title.uiObject.position.copy(this.currentLevel.zSpacePositions.zSpacePosition);
            // @ts-ignore
            if (level.errorModal)
                level.errorModal.uiObject.scale.multiplyScalar(this.app.determineZSpaceDevice.viewerScaleCoef);
            // @ts-ignore
            if (this.currentLevel === this)
                level.title.uiObject.visible = !this.welcomeScreen.uiObject.visible;
            // @ts-ignore
            // level.table.visible = false;
            level.uiObject.remove(level.table);
        });
        if (this.currentLevel === this) {
            // @ts-ignore
            if (this.tutorialVideo.uiObject.visible)
                this.levelList.forEach((level) => level.title.uiObject.visible = false);
        }
        // @ts-ignore
        if (this.currentLevel.table)
            this.currentLevel.uiObject.add(this.currentLevel.table); // this.currentLevel.table.visible = true;
        // @ts-ignore
        this.levelList[0].title.uiObject.position.x -= 9.5;
        // @ts-ignore
        this.levelList[0].title.uiObject.position.y += 3.5;
        // @ts-ignore
        this.levelList[1].title.uiObject.position.x += 0.0;
        // @ts-ignore
        this.levelList[1].title.uiObject.position.y += 3.5;
        // @ts-ignore
        this.levelList[2].title.uiObject.position.x += 9.5;
        // @ts-ignore
        this.levelList[2].title.uiObject.position.y += 3.5;
        // @ts-ignore
        this.levelList[3].title.uiObject.position.x -= 5;
        // @ts-ignore
        this.levelList[3].title.uiObject.position.y -= 4;
        // @ts-ignore
        this.levelList[4].title.uiObject.position.x += 5;
        // @ts-ignore
        this.levelList[4].title.uiObject.position.y -= 4;
        this.welcomeScreen.uiObject.position.copy(currLevelzSpacePosition);
        this.welcomeScreen.uiObject.scale.setScalar(1.5);
        this.menuBtn.uiObject.position.set(-4.9, 3.75, 0);
        this.menuBtn.uiObject.scale.setScalar(0.4);
        this.menuComponent.uiObject.position.z = 0.1;
        // @ts-ignore
        if (this.levelList[0].zoomModule.dish1.userData.zsPosition) {
            // @ts-ignore
            this.levelList[0].zoomModule.dish1.position.copy(this.levelList[0].zoomModule.dish1.userData.zsPosition);
            // @ts-ignore
            this.levelList[0].zoomModule.dish1.quaternion.copy(this.levelList[0].zoomModule.dish1.userData.zsRotation);
            // @ts-ignore
            this.levelList[0].zoomModule.dish1.scale.setScalar(this.levelList[0].zoomModule.dish1.userData.zsScale);
        }
        // MOLAR LEVEL =======
        // @ts-ignore
        this.levelList[3].periodicModule.uiObject.position.set(-3, 0.87, 0);
        // @ts-ignore
        this.levelList[3].periodicModule.uiObject.scale.setScalar(1.8);
        // @ts-ignore
        this.levelList[3].summationModule.uiObject.position.set(0, -5.4, 0);
        // @ts-ignore
        this.levelList[3].summationModule.uiObject.scale.setScalar(1.5);
        // @ts-ignore
        this.levelList[3].summationGramModule.uiObject.scale.setScalar(1);
        // @ts-ignore
        this.levelList[3].jarModule.applyButton.uiObject.position.set(-3.58, 0, 0);
        // @ts-ignore
        this.levelList[3].jarModule.applyButton.uiObject.scale.setScalar(1.5);
        // @ts-ignore
        if (this.levelList[3].distilledWaterModule.sliderComponent) {
            // @ts-ignore
            this.levelList[3].distilledWaterModule.sliderComponent.uiObject.position.set(3, 0, 0);
            // @ts-ignore
            this.levelList[3].distilledWaterModule.sliderComponent.uiObject.scale.setScalar(2.5);
        }
        // @ts-ignore
        if (this.levelList[3].flaskModule.shakeFlask) {
            // @ts-ignore
            this.levelList[3].flaskModule.shakeFlask.uiObject.position.set(0, 0, 0);
            // @ts-ignore
            this.levelList[3].flaskModule.shakeFlask.uiObject.scale.setScalar(2);
        }
        this.finalScreen.uiObject.position.copy(zSpaceConfig.lobby.zSpacePosition);
        // @ts-ignore
        // this.levelList[3].spoonModule_1.uiObject.visible = this.levelList[3].spoonModule_0_1.uiObject.visible = this.levelList[3].spoonModule_0_5.uiObject.visible = false;
    }
    setPCPosition() {
        const levelCenterPosition = this.currentLevel.uiObject.position.clone();
        levelCenterPosition.y = -15;
        // @ts-ignore
        Viewer.controls.object.position.copy(this.currentLevel.cameraPosition);
        // @ts-ignore
        Viewer.controls.target.copy(this.currentLevel.cameraTargetNormal);
        // LEVELS ========
        this.wrapScreenUI.position.copy(this.wrapScreenUI.userData.pcPosition);
        this.wrapScreenUI.rotation.set(0, 0, 0);
        if (this.currentLevel === this) {
            if (this.wrapScreenUI.parent)
                this.wrapScreenUI.parent.remove(this.wrapScreenUI);
        }
        else
            this.currentLevel.addObject(this.wrapScreenUI);
        // @ts-ignore
        this.wrapHeaderUI.position.copy(this.wrapHeaderUI.userData.pcPosition);
        this.wrapHeaderUI.rotation.set(0, 0, 0);
        this.wrapHeaderUI.scale.setScalar(1);
        // GENERAL UI
        this.welcomeScreen.uiObject.position.copy(this.welcomeScreen.uiObject.userData.pcPosition);
        this.welcomeScreen.uiObject.scale.setScalar(1);
        this.menuBtn.uiObject.position.copy(this.menuBtn.uiObject.userData.pcPosition);
        this.menuBtn.uiObject.scale.setScalar(1);
        this.menuComponent.uiObject.position.z = 1;
        this.levelList.forEach((level) => {
            // @ts-ignore
            level.tasksProgress.uiObject.position.copy(level.tasksProgress.uiObject.userData.pcPosition);
            // @ts-ignore
            level.tasksProgress.uiObject.rotation.set(0, 0, 0);
            // @ts-ignore
            level.taskScreen.uiObject.position.copy(level.taskScreen.uiObject.userData.pcPosition);
            // @ts-ignore
            level.taskScreen.uiObject.rotation.set(0, 0, 0);
            // @ts-ignore
            level.addObject(level.title);
            // @ts-ignore
            level.title.uiObject.scale.setScalar(1);
            // @ts-ignore
            level.addObject(level.uiContainer);
            // @ts-ignore
            level.uiContainer.position.copy(level.uiContainer.userData.pcPosition || new Vector3(0, 0, 0));
            // @ts-ignore
            level.uiContainer.rotation.set(0, 0, 0);
            // @ts-ignore
            level.uiContainer.scale.setScalar(1);
            // @ts-ignore
            level.uiContainer.children.forEach(el => {
                if (el.userData.pcPosition)
                    el.position.copy(el.userData.pcPosition);
            });
            // @ts-ignore
            if (this.currentLevel === this) {
                // @ts-ignore
                level.title.uiObject.visible = true;
            }
            // @ts-ignore
            level.title.uiObject.position.set(0, 10, 0);
            // @ts-ignore
            // level.table.visible = true;
            level.uiObject.add(level.table);
        });
        this.tutorialVideo.uiObject.position.copy(this.tutorialVideo.uiObject.userData.pcPosition);
        this.tutorialVideo.uiObject.lookAt(this.controls.object.position.clone());
        this.tutorialVideo.uiObject.scale.setScalar(1);
        this.finalScreen.uiObject.position.set(0, -7, 16);
        // @ts-ignore
        if (this.levelList[0].zoomModule.dish1.userData.pcPosition) {
            // @ts-ignore
            this.levelList[0].zoomModule.dish1.position.copy(this.levelList[0].zoomModule.dish1.userData.pcPosition);
            // @ts-ignore
            this.levelList[0].zoomModule.dish1.quaternion.copy(this.levelList[0].zoomModule.dish1.userData.pcRotation);
            // @ts-ignore
            this.levelList[0].zoomModule.dish1.scale.setScalar(this.levelList[0].zoomModule.dish1.userData.pcScale);
        }
        // MOLAR LEVEL =======
        // @ts-ignore
        this.levelList[3].periodicModule.uiObject.position.copy(this.levelList[3].periodicModule.uiObject.userData.pcPosition);
        // @ts-ignore
        this.levelList[3].periodicModule.uiObject.scale.setScalar(this.levelList[3].periodicModule.uiObject.userData.pcScale);
        // @ts-ignore
        this.levelList[3].summationModule.uiObject.position.copy(this.levelList[3].summationModule.uiObject.userData.pcPosition);
        // @ts-ignore
        this.levelList[3].summationModule.uiObject.scale.setScalar(1);
        // @ts-ignore
        this.levelList[3].summationGramModule.uiObject.scale.setScalar(0.8);
        // @ts-ignore
        this.levelList[3].jarModule.applyButton.uiObject.position.set(-2.5831736994195826, -2.6729500711734735, 4.107728494627179);
        // @ts-ignore
        this.levelList[3].jarModule.applyButton.uiObject.scale.setScalar(1);
    }
    init(event) {
        super.init(event);
        console.log('======= init LOBBY');
        this.currentLevel = this;
        this.addObject(this.wrapHeaderUI = new Object3D());
        this.wrapHeaderUI.position.set(0, 20, -45);
        this.wrapHeaderUI.userData.pcPosition = this.wrapHeaderUI.position.clone();
        this.logo = new Mesh(new PlaneGeometry(5.4 * 5, 1.2 * 5), new MeshBasicMaterial({ map: ResourcesManager.getTexture('logo_image'), transparent: true }));
        this.wrapHeaderUI.add(this.logo);
        this.muteBtn = new IconButtonComponent({
            diameter: 3.8,
            iconSize: 0.85,
            text: this.app.muted ? '' : '',
            background: styleConfig.MAIN_BACKGROUND_COLOR.getStyle(),
        });
        this.muteBtn.uiObject.name = 'MuteBtn';
        this.muteBtn.uiObject.position.set(-18, -1, 0);
        this.wrapHeaderUI.add(this.muteBtn.uiObject);
        this.muteBtn.on(ActionControllerEventName.click, () => this.toggleSound());
        const exitExperience = new ButtonComponent({
            type: 'flat',
            size: new Vector3(8 * 1.5, 2 * 1.5, 0.1),
            sizePx: new Vector2(256, 64),
            bordRadius: 0.7,
            background: { color: styleConfig.MAIN_BACKGROUND_COLOR.getStyle() },
            text: {
                value: 'Exit experience'.toUpperCase(),
                lineHeight: 50,
                style: { size: '48px', color: 'white', family: 'Nunito', weight: '800' },
                margin: { top: 19, right: 31, bottom: 29, left: 31 },
            }
        });
        exitExperience.uiObject.position.set(25, -1, 0);
        this.wrapHeaderUI.add(exitExperience.uiObject);
        exitExperience.on(ActionControllerEventName.click, () => window.close());
        this.wrapScreenUI = new Object3D();
        this.wrapScreenUI.name = 'WrapScreenUI';
        this.wrapScreenUI.position.set(0, 9.48, -10);
        this.wrapScreenUI.userData.pcPosition = this.wrapScreenUI.position.clone();
        this.addObject(this.welcomeScreen = new WelcomeScreen());
        this.welcomeScreen.uiObject.position.set(0, -7, 16);
        this.welcomeScreen.uiObject.userData.pcPosition = this.welcomeScreen.uiObject.position.clone();
        this.welcomeScreen.init('Welcome!', 'Press "START" once you are ready to start.', 'START');
        this.addObject(this.tutorialVideo = new TutorialVideoComponent());
        this.tutorialVideo.uiObject.position.set(0, -6, 14);
        this.tutorialVideo.uiObject.userData.pcPosition = this.tutorialVideo.uiObject.position.clone();
        this.tutorialVideo.uiObject.visible = false;
        this.tutorialVideo.uiObject.name = 'TUTORIALVideo';
        this.tutorialVideo.init();
        this.tutorialVideo.on('ended', () => {
            this.tutorialVideo.uiObject.visible = false;
            this.videoIsRunning = false;
            // @ts-ignore
            this.levelList.forEach((level) => level.title.uiObject.visible = true);
        });
        this.initMenu();
        this.initScenario();
        this.initFinalScreen();
        this.initZSpaceSettings();
        this.initChangeModeModal();
        if (Viewer.controls.zController)
            this.setZSpacePosition();
        if (Viewer.zSpace)
            this.initZSpaceOnChangeValidator();
    }
    initZSpaceOnChangeValidator() {
        Viewer.zSpace.onChangeValidator = () => {
            this.changeModeModal.setModeName(Viewer.controls.zController ? 'normal' : 'zSpace');
            this.changeModeModal.show();
            return false;
        };
    }
    initChangeModeModal() {
        this.changeModeModal = new ChangeModeModal();
        this.changeModeModal.on('ok', () => {
            setTimeout(() => {
                Viewer.zSpace.onChangeValidator = () => true;
                Viewer.zSpace.enabled = !Viewer.zSpace.enabled;
                this.initZSpaceOnChangeValidator();
            }, 100);
        });
        this.changeModeModal.on('cancel', () => {
            Viewer.zSpace.onChangeValidator = () => false;
            Viewer.zSpace.enabled = false;
            this.initZSpaceOnChangeValidator();
        });
    }
    initScenario() {
        this.scenario = {
            name: 'lobby',
            modules: [{ name: 'module', instance: this.welcomeScreen }],
            steps: [{
                    onBefore: [
                        () => this.initLevels(),
                    ],
                    stepCondition: () => new Promise(((resolve) => {
                        this.welcomeScreen.once('ok', () => {
                            this.welcomeScreen.uiObject.visible = false;
                            // @ts-ignore
                            this.levelList.forEach(level => level.title.uiObject.visible = true);
                            this.app.initMainTheme();
                            this.initLevelsEvents();
                            resolve();
                        });
                    })),
                }, {}]
        };
        const scenarioProcessor = new ScenarioProcessor(this.scenario);
        scenarioProcessor.init();
    }
    showLevelsInfo() {
        this.levelList.forEach(level => level.hideAllInfo());
    }
    hideLevelInfo(levelToShow) {
        this.levelList.forEach(level => level.hideAllInfo());
        // (<any>levelToShow).showInfo(false);
    }
    initLevels() {
        this.levelList.push(new PetriLevel(1, 'Colony Isolation and Streaking Bacteria', this));
        this.levelList.push(new MicropipetteLevel(2, 'Using Micropipettes', this));
        this.levelList.push(new SerologicalLevel(3, 'Serological Pipettes', this));
        this.levelList.push(new MolarLevel(4, 'Making a Molar Solution', this));
        this.levelList.push(this.spectrophotometerLevel);
        this.spectrophotometerLevel.init();
        const posRotList = [
            { position: new Vector3(-43.48, -15.0, 6), rotationY: 1.06 },
            { position: new Vector3(-24.62, -15.0, -11.04), rotationY: 0.54 },
            { position: new Vector3(0, -15.0, -19.36), rotationY: 0 },
            { position: new Vector3(23.14, -15.0, -9.66), rotationY: -0.54 },
            { position: new Vector3(43.48, -14.977381194309281, 6), rotationY: -1.06 },
        ];
        this.levelList.forEach((level, index) => {
            level.uiObject.name = 'Level_' + (index + 1);
            level.uiObject.position.copy(posRotList[index].position);
            level.uiObject.rotateY(posRotList[index].rotationY);
            // @ts-ignore
            level.uiContainer.children.forEach(el => el.userData.pcPosition = el.position.clone());
            // @ts-ignore
            level.tasksProgress.uiObject.userData.pcPosition = level.tasksProgress.uiObject.position.clone();
            // @ts-ignore
            level.taskScreen.uiObject.userData.pcPosition = level.taskScreen.uiObject.position.clone();
            // @ts-ignore
            level.welcomeScreen.uiObject.userData.pcPosition = level.welcomeScreen.uiObject.position.clone();
            if (level.uiObject.parent) {
                level.uiObject.parent.remove(level.uiObject);
                this.uiObject.add(level.uiObject);
            }
            else {
                this.addObject(level);
            }
        });
    }
    initLevelsEvents() {
        this.levelList.forEach((level) => {
            level.on('inDev', () => {
                if (this.videoIsRunning)
                    return;
                level.fire('showError');
            });
            level.on('start', () => {
                if (this.videoIsRunning)
                    return;
                level.fire('started');
                this.flyToLevel(level);
            });
            level.on('exit', () => {
                InputManager.hideKeyboard();
                console.log('level.on(\'exit\'');
                this.exitToLobby();
            });
            level.on('tutorial', () => {
                if (this.videoIsRunning)
                    return;
                const videoPosition = level.uiObject.position.clone().lerp(this.cameraPosition.clone(), .8);
                this.tutorialVideo.setTutorialVideo(ResourcesManager.getVideo(level.uiObject.name + '_video'));
                this.tutorialVideo.uiObject.position.copy(videoPosition);
                this.tutorialVideo.uiObject.position.y = -7.5;
                this.tutorialVideo.uiObject.lookAt(this.cameraPosition.clone());
                this.tutorialVideo.uiObject.userData.pcPosition = this.tutorialVideo.uiObject.position.clone();
                this.tutorialVideo.uiObject.userData.pcRotation = this.tutorialVideo.uiObject.rotation.clone();
                if (Viewer.controls.zController) {
                    // @ts-ignore
                    this.levelList.forEach((level) => level.title.uiObject.visible = false);
                    this.tutorialVideo.uiObject.position.copy(Viewer.controls.zController.position);
                    this.tutorialVideo.uiObject.rotation.set(0, 0, 0);
                    this.tutorialVideo.uiObject.scale.setScalar(2);
                }
                this.videoIsRunning = true;
            });
        });
    }
    exitToLobby() {
        this.wrapHeaderUI.visible = true;
        this.showMenu(false);
        const objectToTranslate = this.controls.isVR ? this.camera.parent : this.camera;
        const oldPosition = objectToTranslate.position.clone();
        const newPosition = this.cameraPosition.clone();
        const oldTarget = this.controls.target.clone();
        const newTarget = this.cameraTargetNormal.clone();
        // @ts-ignore
        if (Viewer.controls.zController && this.currentLevel.table) {
            // this.currentLevel.table.visible = false;
            // @ts-ignore
            this.currentLevel.uiObject.remove(this.currentLevel.table);
        }
        if (this.currentLevel === this.levelList[1]) {
            // @ts-ignore
            if (this.currentLevel.instruments.pipette.sliderPistonComponent.uiObject.visible)
                // @ts-ignore
                this.currentLevel.instruments.pipette.uiObject.visible = false;
        }
        this.currentLevel = this;
        const flyDuration = Viewer.controls.zController ? 10 : 1500;
        new TWEEN.Tween({ alpha: 0 }).to({ alpha: 1 }, flyDuration)
            .easing(TWEEN.Easing.Quadratic.Out)
            .onStart(() => {
            this.showLevelsInfo();
            this.wrapScreenUI.parent.remove(this.wrapScreenUI);
        })
            .onUpdate((alpha) => {
            this.controls.enabled = false;
            const currCord = oldPosition.clone().lerp(newPosition, alpha);
            objectToTranslate.position.copy(currCord);
            const currTargetPos = oldTarget.clone().lerp(newTarget, alpha);
            this.controls.target.copy(currTargetPos);
            this.controls.update();
        })
            .onComplete(() => {
            this.controls.enabled = true;
            this.levelList.forEach(level => level.showInfo(true));
            if (Viewer.controls.zController)
                this.setZSpacePosition();
        })
            .start();
        // @ts-ignore
        if (this.levelList.filter(level => !level.levelFinished).length === 0) {
            this.videoIsRunning = true; // prevents levels to be entered or video played
            this.sendResults().then(() => {
                this.finalScreen.uiObject.position.set(0, -7, 16);
                if (Viewer.controls.zController) {
                    this.finalScreen.uiObject.position.copy(this.zSpacePositions.zSpacePosition);
                    this.finalScreen.uiObject.position.z += 0.1;
                }
                this.finalScreen.uiObject.visible = true;
            });
        }
    }
    flyToLevel(level) {
        this.wrapHeaderUI.visible = false;
        level.uiObject.add(level.table);
        const objectToTranslate = this.controls.isVR ? this.camera.parent : this.camera;
        const levelCenterPosition = level.uiObject.position.clone();
        levelCenterPosition.y = -15;
        const oldPosition = objectToTranslate.position.clone();
        const newPosition = (this.controls.isVR && level.cameraPositionVR) ? level.cameraPositionVR.clone() : level.cameraPosition.clone();
        const oldTarget = this.controls.target.clone();
        const newTarget = level.cameraTargetNormal.clone();
        this.currentLevel = level;
        const flyDuration = Viewer.controls.zController ? 10 : 1500;
        new TWEEN.Tween({ alpha: 0 }).to({ alpha: 1 }, flyDuration)
            .easing(TWEEN.Easing.Quadratic.Out)
            .onStart(() => this.hideLevelInfo(level))
            .onUpdate((alpha) => {
            this.controls.enabled = false;
            const currCord = oldPosition.clone().lerp(newPosition, alpha);
            objectToTranslate.position.copy(currCord);
            const currTargetPos = oldTarget.clone().lerp(newTarget, alpha);
            this.controls.target.copy(currTargetPos);
            this.controls.update();
        })
            .onComplete(() => {
            level.showInfo(false);
            this.controls.enabled = true;
            if (Viewer.controls.zController)
                this.setZSpacePosition();
            // @ts-ignore
            if (level === this.levelList[1])
                this.currentLevel.instruments.pipette.uiObject.visible = true;
            if (level.wrapScreenPosition) {
                if (!Viewer.controls.zController) {
                    this.wrapScreenUI.position.copy(level.wrapScreenPosition);
                    level.addObject(this.wrapScreenUI);
                }
                this.wrapScreenUI.userData.pcPosition = level.wrapScreenPosition.clone();
            }
        })
            .start();
        if (Viewer.controls.zController)
            this.setZSpacePosition();
    }
    initFinalScreen() {
        this.finalScreen = new WelcomeScreen();
        this.addObject(this.finalScreen);
        this.finalScreen.uiObject.visible = false;
        this.finalScreen.uiObject.position.set(0, -7, 16);
        if (Viewer.controls.zController) {
            this.finalScreen.uiObject.position.copy(this.zSpacePositions.zSpacePosition);
            this.finalScreen.uiObject.position.z += 0.1;
        }
        this.finalScreen.init('Great!', 'Now you have done all levels.', 'Print results');
        this.finalScreen.once('ok', () => this.goToPdf());
        Viewer.on('goToZSpace', () => {
            this.finalScreen.uiObject.position.copy(this.zSpacePositions.zSpacePosition);
            this.finalScreen.uiObject.position.z += 0.1;
        });
        Viewer.on('goFromZSpace', () => {
            this.finalScreen.uiObject.position.set(0, -7, 16);
        });
    }
    goToPdf() {
        if (this.controls.isVR) {
            Viewer.renderer.xr.getSession().end().then(() => {
                setTimeout(() => SessionController.openPDF(), 1000);
            });
        }
        else {
            SessionController.openPDF();
        }
    }
    sendResults() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.resultsSent)
                return;
            this.resultsSent = true;
            const levelNames = [
                'Colony Isolation and Streaking Bacteria',
                'Using Micropipettes',
                'Serological Pipettes',
                'Making a Molar Solution',
                'Dilutions & Spectrophotometry'
            ];
            for (let i = 1; i <= 5; i++) {
                yield SessionController.init(null, null, 'Biotechnology', null, 5);
                const payload = {
                    'score': 20,
                    'max_score': 20,
                    'level_name': levelNames[i - 1],
                    'level_number': i
                };
                yield SessionController.updateSessionEntries(payload, 20, 20);
            }
            yield SessionController.endSession('items');
        });
    }
    animProperty(object, property, oldVal, newVal) {
        this.currTweenClothes = new TWEEN.Tween({ alpha: oldVal }).to({ alpha: newVal }, 700)
            .onUpdate((alpha) => {
            object[property] = (oldVal > newVal) ? alpha : newVal - alpha;
        })
            .onComplete(() => this.animProperty(object, property, newVal, oldVal))
            .start();
    }
    initMenu() {
        this.menuBtn = new ButtonComponent({
            size: new Vector3(1.4, 1.4, 1),
            sizePx: new Vector2(64, 64),
            type: 'icon',
            text: {
                value: '',
                style: { color: 'white', family: 'FontAwesome', size: '36px' },
                margin: { top: 0, bottom: 15 }
            },
            background: { color: styleConfig.MAIN_BACKGROUND_COLOR.getStyle() }
        });
        this.menuBtn.uiObject.position.set(-3.2, 1.7, 0);
        this.menuBtn.uiObject.userData.pcPosition = this.menuBtn.uiObject.position.clone();
        this.menuBtn.uiObject.name = 'menuBtn';
        this.wrapScreenUI.add(this.menuBtn.uiObject);
        this.menuComponent = new MainMenuComponent({
            innerRadius: 0.9,
            outerRadius: 1.95,
            borderWidth: 0.015,
            borderColor: styleConfig.BUTTON_BACKGROUND_COLOR.getHex(),
            bgColor: styleConfig.MENU_BACKGROUND_COLOR.getHex(),
            centerText: {
                value: '',
                style: { color: 'black', size: '32px' },
                align: 'center',
                lineHeight: 60,
                margin: { bottom: 40 },
                autoWrappingHorizontal: false,
                autoWrapping: true
            },
            sectorColors: {
                default: styleConfig.BUTTON_BACKGROUND_COLOR.getHex(),
                hover: styleConfig.BUTTON_HOVER_COLOR.getHex(),
            },
            enableCancelButton: true,
        });
        this.menuComponent.uiObject.position.set(0, 0, 1);
        this.menuComponent.uiObject.visible = false;
        this.menuComponent.uiObject.name = 'menuComponent';
        this.wrapScreenUI.add(this.menuComponent.uiObject);
        if (this.app.muted)
            this.menuComponent.soundMeshButton.setText('');
        this.menuBtn.on(ActionControllerEventName.click, () => {
            if (this.app.pointerController.currentPointerObject === this.app.pointerController.defaultPointerObject ||
                this.app.pointerController.currentPointerObject === undefined ||
                this.app.pointerController.currentPointerObject === null) {
                this.showMenu(true);
            }
        });
        this.menuComponent.on('play', () => this.showMenu(false));
        this.menuComponent.on('canceled', () => this.showMenu(false));
        this.menuComponent.on('exit', () => {
            if (this.app.pointerController.currentPointerObject === this.app.pointerController.defaultPointerObject ||
                this.app.pointerController.currentPointerObject === undefined ||
                this.app.pointerController.currentPointerObject === null) {
                this.levelList.forEach((level) => {
                    if (level.interaction)
                        level.interaction = false;
                });
                console.log('this.menuComponent.on(\'exit\'');
                this.exitToLobby();
            }
        });
        this.menuComponent.on('toggleSound', () => this.toggleSound(true));
        // this.cancelMenuButton.on(ActionControllerEventName.click, () => this.toggleMenu());
    }
    toggleSound(isFromMenu = false) {
        if (this.app.muted)
            ResourcesManager.getAudioManger().unMuteAll();
        else
            ResourcesManager.getAudioManger().muteAll();
        this.app.muted = !this.app.muted;
        this.muteBtn.setText(this.app.muted ? '' : '');
        if (!isFromMenu)
            this.menuComponent.soundMeshButton.setText(this.app.muted ? '' : '');
    }
    showMenu(isShow = true) {
        this.menuBtn.uiObject.visible = !isShow;
        this.menuComponent.uiObject.visible = isShow;
    }
    startAnimation() {
        console.log('startAnimation');
        clearInterval(window['intZSpacePreloader']);
        if (Viewer.controls.zController)
            Viewer.scene.remove(this.app.preloader.uiObject);
        return super.startAnimation().then(() => {
        });
    }
    endAnimation() {
        console.log('endAnimation');
        return super.endAnimation().then(() => {
        });
    }
}
